export const ganttPreviewColors = ["#B0B0B0", "#9A9A9A", "#797979", "#555555"];